import { utcFormat } from 'd3-time-format';
import type { TimeInterval } from 'd3-time';
import { timeWeek, timeMonth, timeYear } from 'd3-time';
import { getTimeSeriesPeriodMap } from './timeSeriesPeriodMap';

const formatDate1M3M = utcFormat('%e %b');
const formatDate1M6M = utcFormat('%e %b');
const formatDate1Y6Y = utcFormat('%b %y');
const formatDate1Y3Y = utcFormat('%b %y');
const formatDate5YMax = utcFormat('%Y');

type TickFormat = ((date: Date) => string) | ((date: number) => string);

export interface PeriodItem {
  period: number;
  label: string;
  labelAria: string;
  tickFormat: (TimeInterval | null)[];
  tickLabelFormat: TickFormat[];
}

/**
 * The endpoint the PriceChart consumes its data from requires its 5Y time
 * period to be 5 minutes short of exactly 5 years (can't remember why).
 * So here we consume a default PeriodMap from getTimeSeriesPeriodMap and
 * mutate its 5Y.
 */
export const getPriceChartTimeSeriesPeriodMap = (
  date?: Date
): ReturnType<typeof getTimeSeriesPeriodMap> => {
  const periodMap = getTimeSeriesPeriodMap(date);

  const now = new Date(periodMap.NOW);
  const TY = now.getFullYear();
  const TM = now.getMonth();
  const TD = now.getDate();
  const TH = now.getHours();
  const TMM = now.getMinutes();

  periodMap['5Y'] = new Date(TY - 5, TM, TD, TH, TMM + 5).getTime();

  return periodMap;
};

export const getPeriodList = (
  periodMap: ReturnType<typeof getTimeSeriesPeriodMap>
): PeriodItem[] => [
  // {
  //   period: periodMap['1D'],
  //   label: '1D',
  //   labelAria: '1 day',
  //   tickFormat: [timeDay.every(1), timeDay.every(1)],
  //   tickLabelFormat: [formatDate1M3M, formatDate1M3M],
  // },
  // {
  //   period: periodMap['5D'],
  //   label: '5D',
  //   labelAria: '5 days',
  //   tickFormat: [timeDay.every(1), timeDay.every(1)],
  //   tickLabelFormat: [formatDate1M3M, formatDate1M3M],
  // },
  // {
  //   period: periodMap['7D'],
  //   label: '7D',
  //   labelAria: '7 days',
  //   tickFormat: [timeDay.every(1), timeDay.every(2)],
  //   tickLabelFormat: [formatDate1M3M, formatDate1M3M],
  // },
  {
    period: periodMap['1M'],
    label: '1M',
    labelAria: '1 month',
    tickFormat: [timeWeek.every(1), timeWeek.every(2)],
    tickLabelFormat: [formatDate1M3M, formatDate1M3M],
  },
  {
    period: periodMap['6M'],
    label: '6M',
    labelAria: '6 months',
    tickFormat: [timeMonth.every(1), timeMonth.every(2)],
    tickLabelFormat: [formatDate1M6M, formatDate1Y6Y],
  },
  {
    period: periodMap['1Y'],
    label: '1Y',
    labelAria: '1 year',
    tickFormat: [timeMonth.every(1), timeMonth.every(2)],
    tickLabelFormat: [formatDate1Y3Y, formatDate1Y3Y],
  },
  // {
  //   period: periodMap['3Y'],
  //   label: '3Y',
  //   labelAria: '3 years',
  //   tickFormat: [timeMonth.every(3), timeYear.every(1)],
  //   tickLabelFormat: [formatDate1Y3Y, formatDate5YMax],
  // },
  // {
  //   period: periodMap['5Y'],
  //   label: '5Y',
  //   labelAria: '5 years',
  //   tickFormat: [timeYear.every(1), timeYear.every(1)],
  //   tickLabelFormat: [formatDate5YMax, formatDate5YMax],
  // },
  {
    period: periodMap.MAX,
    label: 'Max',
    labelAria: 'Max',
    tickFormat: [timeYear.every(5), timeYear.every(5)],
    tickLabelFormat: [formatDate5YMax, formatDate5YMax],
  },
];
